var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
import * as React from 'react';
const swatchStyle = (bg) => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 18,
    height: 18,
    marginRight: 8,
    borderRadius: 2,
    background: bg || '#29c7ee',
    color: '#fff',
    fontSize: 11,
    fontWeight: 700,
    flex: '0 0 auto',
});
/**
 * Event Legend list (F1) — React port of the `Event Legend` dropdown in `fmforecastview.html`
 * (`ng-repeat="x in sample.calendarMasterData.EventTypes"`): a colored one-letter swatch
 * (`EventColor` background, `EventTypeName | limitTo:1`) beside each event-type name.
 */
export const EventLegend = ({ eventTypes }) => (React.createElement("ul", { "data-testid": "event-legend", role: "menu", "aria-label": "Event legend", style: {
        listStyle: 'none',
        margin: 0,
        padding: 8,
        maxHeight: 320,
        overflowY: 'auto',
        minWidth: 220,
    } }, eventTypes.length === 0 ? (React.createElement("li", { style: { padding: '4px 8px', color: '#605e5c' } }, "No event types.")) : (eventTypes.map((x) => (React.createElement("li", { key: x.EventTypeId, role: "menuitem", style: { display: 'flex', alignItems: 'center', padding: '3px 8px', fontSize: 13 } },
    React.createElement("span", { "aria-hidden": "true", style: swatchStyle(x.EventColor) }, (x.EventTypeName || '').charAt(0)),
    React.createElement("span", null, x.EventTypeName)))))));
export default EventLegend;
//# sourceMappingURL=EventLegend.js.map